import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 16,
  path: '/setting',
  component: Home,
  redirect: '/setting/setting/notice',
  name: 'setting',
  isHead: true,
  meta: {
    title: '系统配置',
    icon: 'el-icon-setting'
  },
  children: [
    {
      path: 'setting',
      component: () => import('@/views/setting/index'),
      name: 'Setting',
      meta: { title: '系统配置', close: false },
      children: [
        // 通知公告
        {
          path: 'notice',
          name: 'notice',
          component: () => import('@/views/department/notice/table'),
          meta: { title: '新建通知', next: '/setting/setting/sent', close: true }
        },
        {
          path: 'sent',
          name: 'sent',
          component: () => import('@/views/department/sent/table'),
          meta: { title: '已发通知', next: '/setting/setting/received', close: true }
        },
        {
          path: 'received',
          name: 'received',
          component: () => import('@/views/department/received/table'),
          meta: { title: '已收通知', next: '/setting/setting/departmentManagement', close: true }
        },
        {
          path: 'departmentManagement',
          name: 'departmentManagement',
          component: () =>
            import('@/views/department/management/managementPage'),
          meta: { title: '部门账号配置', next: '/setting/setting/townManagement', close: true }
        },
        {
          path: 'townManagement',
          name: 'townManagement',
          component: () => import('@/views/town/management/managementPage'),
          meta: { title: '乡镇账号配置', next: '/setting/setting/villageManagement', close: true }
        },
        {
          path: 'villageManagement',
          name: 'villageManagement',
          component: () => import('@/views/village/management/managementPage'),
          meta: { title: '村账号配置', next: '/setting/setting/departmentTypeManage', close: true }
        },
        {
          path: 'areaManagement',
          name: 'areaManagement',
          component: () => import('@/views/systemSetting/areaManagement'),
          meta: { title: '区域信息配置', next: '/setting/setting/AccountManagement', close: true }
        },
        {
          path: 'AccountManagement',
          name: 'AccountManagement',
          component: () => import('@/views/systemSetting/manageAccount/index'),
          meta: { title: '管理员账号配置', next: '/setting/setting/departmentManagement', close: true }
        },
        {
          path: 'departmentTypeManage',
          name: 'departmentTypeManage',
          component: () =>
            import('@/views/systemSetting/departmentTypeManage/index'),
          meta: { title: '部门类型管理', next: '/setting/setting/departmentManage', close: true }
        },
        {
          path: 'departmentManage',
          name: 'departmentManage',
          component: () =>
            import('@/views/systemSetting/departmentManage/index'),
          meta: { title: '部门管理', next: '/setting/setting/permissionManage', close: true }
        },
        {
          path: 'permissionManage',
          name: 'permissionManage',
          component: () =>
            import('@/views/systemSetting/permissionManage/index'),
          meta: { title: '权限配置', next: '/setting/setting/roleManage', close: true }
        },
        {
          path: 'roleManage',
          name: 'roleManage',
          component: () =>
            import('@/views/systemSetting/roleManage/index'),
          meta: { title: '角色配置', next: '/setting/setting/operationParameter', close: true }
        },
        {
          path: 'operationParameter',
          name: 'operationParameter',
          component: () =>
            import('@/views/systemSetting/operationParameter'),
          meta: { title: '运行参数配置', next: '/setting/setting/operationLog', close: true }
        },
        {
          path: 'operationLog',
          name: 'operationLog',
          component: () =>
            import('@/views/systemSetting/operationLog'),
          meta: { title: '操作日志', next: '/setting/setting/entryLog', close: true }
        },
        {
          path: 'entryLog',
          name: 'entryLog',
          component: () =>
            import('@/views/systemSetting/entryLog'),
          meta: { title: '登录日志', next: '/setting/setting/administrativeConfiguration', close: true }
        },
        {
          path: 'administrativeConfiguration',
          name: 'administrativeConfiguration',
          component: () =>
            import('@/views/systemSetting/administrativeConfiguration/index'),
          meta: { title: '行政区域配置（机构端）', close: true }
        }
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/setting.js